import useNotification from "./useNotification"
import useDebouncedCallback from "./useDebouncedCallback"

const hooks = {
    useNotification,
    useDebouncedCallback
}
export default hooks